import React, { useState, useEffect } from "react";
import { Row, Col, Container } from "deltoid/core/Blocks/BootstrapContainers";
import { connect } from "react-redux";
import { toastActions, manualUploadActions, manualUploadSelectors } from "@store/ducks";
import { INDIVIDUAL_DOC_UPLOAD_STATUS } from "@constants/manualUploadConstants";
import SingleFileUploader from "./SingleFileUploader";

const Uploader = ({
  uploadFile,
  removeFile,
  documentCategoryId,
  documentTypeId,
  maxFileSizeLimit,
  uploadedDocument,
  uploadedDocumentStatus,
  multiple,
  onFileRemove,
  onUploadIconClick,
  showToast,
  setUploadedFile,
  resetSingleFileUploader,
  kycDocumentStatus,
}) => {
  useEffect(() => {
    setUploaderState(uploadedDocumentStatus);
  }, [uploadedDocumentStatus]);
  useEffect(() => {
    setDocUUID(uploadedDocument ? uploadedDocument.kyc_document_uuid : "");
  }, [uploadedDocument]);

  const [uploaderState, setUploaderState] = useState(uploadedDocumentStatus);
  const [docUUID, setDocUUID] = useState(uploadedDocument ? uploadedDocument.kyc_document_uuid : "");

  const handleFileUpload = ([file]) => {
    let fileData = new FormData();
    fileData.append("processed_document", file);
    fileData.append("document_category_id", documentCategoryId);
    fileData.append("document_type_id", documentTypeId);
    setUploaderState("uploading");
    uploadFile(fileData, (kyc_document) => {
      showToast("success", "Success", `The files was uploaded successfully.`);
      setDocUUID(kyc_document.processed_document.kyc_document_uuid);
      if (
        kyc_document.status === INDIVIDUAL_DOC_UPLOAD_STATUS.DOCUMENT_SUBMITTED ||
        kyc_document.status === INDIVIDUAL_DOC_UPLOAD_STATUS.DOCUMENT_VERIFIED ||
        kyc_document.status === INDIVIDUAL_DOC_UPLOAD_STATUS.DOCUMENT_REUPLOADED ||
        kyc_document.status === INDIVIDUAL_DOC_UPLOAD_STATUS.COUNTER_SIGNED ||
        kyc_document.status === INDIVIDUAL_DOC_UPLOAD_STATUS.ACCEPTED
      ) {
        setUploaderState("uploaded");
        setUploadedFile(kyc_document);
      } else if (kyc_document.status === INDIVIDUAL_DOC_UPLOAD_STATUS.DOCUMENT_REJECTED) {
        showToast("error", "Error", `The file could not be uploaded. Please remove the file and try again.`);
        setUploaderState("uploadError");
      }
    });
  };

  const handleFileRejected = ([rejectedFile]) => {
    showToast("warning", "Warning", `The file was rejected. Please try again.`);
    setUploaderState("uploadError");
  };

  const handleFileRemove = (callback) => {
    setUploaderState("uploading");
    removeFile(docUUID, (response) => {
      if (response) {
        showToast("success", "Success", `The file was removed successfully.`);
        setUploaderState("initial");
        setDocUUID("");
        callback("initial");
        onFileRemove();
      } else {
        callback("uploaded");
        setUploaderState("uploaded");
      }
    });
  };

  return (
    <SingleFileUploader
      onFileDropAccepted={handleFileUpload}
      onFileDropRejected={handleFileRejected}
      uploaderState={uploaderState}
      uploadedDocument={uploadedDocument}
      allowedFileExtensions="image/png, application/pdf, image/jpg, image/jpeg"
      maxFileSizeInMB={maxFileSizeLimit}
      onRemove={handleFileRemove}
      disabled={!documentTypeId || (kycDocumentStatus && kycDocumentStatus === INDIVIDUAL_DOC_UPLOAD_STATUS.DOCUMENT_VERIFIED)}
      multiple={false}
      onUploadIconClick={onUploadIconClick}
      resetSingleFileUploader={resetSingleFileUploader}
      kycDocumentStatus={kycDocumentStatus}
    />
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  uploadFile: (fileData, callback) => dispatch(manualUploadActions.uploadFile(fileData, callback)),
  removeFile: (docUUID, callback) => dispatch(manualUploadActions.removeFile(docUUID, callback)),
  showToast: (variant, title, content) =>
    dispatch(toastActions.show({ variant: variant, title: title, content: content })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Uploader);
